import { useContext } from 'react';

import type { TruncationMode } from '@dynatrace/strato-components/typography';

import { TimeseriesTruncationModeContext } from '../context/TimeseriesTruncationMode.context.js';

export const useTruncationMode = (): TruncationMode =>
  useContext(TimeseriesTruncationModeContext);
